export const countries = {
  US: { gb: "United States", fr: "États-Unis", de: "Vereinigte Staaten" },
  Canada: { gb: "Canada", fr: "Canada", de: "Kanada" },
  Afghanistan: { gb: "Afghanistan", fr: "Afghanistan", de: "Afghanistan" },
  Albania: { gb: "Albania", fr: "Albanie", de: "Albanien" },
  Algeria: { gb: "Algeria", fr: "Algérie", de: "Algerien" },
  "American Samoa": {
    gb: "American Samoa",
    fr: "Samoa américaines",
    de: "Amerikanisch-Samoa",
  },
  Andorra: { gb: "Andorra", fr: "Andorre", de: "Andorra" },
  Angola: { gb: "Angola", fr: "Angola", de: "Angola" },
  Anguilla: { gb: "Anguilla", fr: "Anguilla", de: "Anguilla" },
  Antarctica: { gb: "Antarctica", fr: "Antarctique", de: "Antarktis" },
  "Antigua and Barbuda": {
    gb: "Antigua and Barbuda",
    fr: "Antigua-et-Barbuda",
    de: "Antigua und Barbuda",
  },
  Argentina: { gb: "Argentina", fr: "Argentine", de: "Argentinien" },
  Armenia: { gb: "Armenia", fr: "Arménie", de: "Armenien" },
  Aruba: { gb: "Aruba", fr: "Aruba", de: "Aruba" },
  Australia: { gb: "Australia", fr: "Australie", de: "Australien" },
  Austria: { gb: "Austria", fr: "Autriche", de: "Österreich" },
  Azerbaijan: { gb: "Azerbaijan", fr: "Azerbaïdjan", de: "Aserbaidschan" },
  Bahamas: { gb: "Bahamas", fr: "Bahamas", de: "Bahamas" },
  Bahrain: { gb: "Bahrain", fr: "Bahreïn", de: "Bahrain" },
  Bangladesh: { gb: "Bangladesh", fr: "Bangladesh", de: "Bangladesch" },
  Barbados: { gb: "Barbados", fr: "Barbade", de: "Barbados" },
  Belarus: { gb: "Belarus", fr: "Biélorussie", de: "Weißrussland" },
  Belgium: { gb: "Belgium", fr: "Belgique", de: "Belgien" },
  Belize: { gb: "Belize", fr: "Belize", de: "Belize" },
  Benin: { gb: "Benin", fr: "Bénin", de: "Benin" },
  Bermuda: { gb: "Bermuda", fr: "Bermudes", de: "Bermuda" },
  Bhutan: { gb: "Bhutan", fr: "Bhoutan", de: "Bhutan" },
  Bolivia: { gb: "Bolivia", fr: "Bolivie", de: "Bolivien" },
  "Bosnia and Herzegovina": {
    gb: "Bosnia and Herzegovina",
    fr: "Bosnie-Herzégovine",
    de: "Bosnien und Herzegowina",
  },
  Botswana: { gb: "Botswana", fr: "Botswana", de: "Botswana" },
  Brazil: { gb: "Brazil", fr: "Brésil", de: "Brasilien" },
  "British Indian Ocean Territory": {
    gb: "British Indian Ocean Territory",
    fr: "Territoire britannique de l'océan Indien",
    de: "Britisches Territorium im Indischen Ozean",
  },
  "British Virgin Islands": {
    gb: "British Virgin Islands",
    fr: "Îles Vierges britanniques",
    de: "Britische Jungferninseln",
  },
  Brunei: { gb: "Brunei", fr: "Brunéi", de: "Brunei" },
  Bulgaria: { gb: "Bulgaria", fr: "Bulgarie", de: "Bulgarien" },
  "Burkina Faso": {
    gb: "Burkina Faso",
    fr: "Burkina Faso",
    de: "Burkina Faso",
  },
  Burundi: { gb: "Burundi", fr: "Burundi", de: "Burundi" },
  Cambodia: { gb: "Cambodia", fr: "Cambodge", de: "Kambodscha" },
  Cameroon: { gb: "Cameroon", fr: "Cameroun", de: "Kamerun" },
  "Cape Verde": { gb: "Cape Verde", fr: "Cap-Vert", de: "Kap Verde" },
  "Cayman Islands": {
    gb: "Cayman Islands",
    fr: "Îles Caïmans",
    de: "Kaimaninseln",
  },
  "Central African Republic": {
    gb: "Central African Republic",
    fr: "République centrafricaine",
    de: "Zentralafrikanische Republik",
  },
  Chad: { gb: "Chad", fr: "Tchad", de: "Tschad" },
  Chile: { gb: "Chile", fr: "Chili", de: "Chile" },
  China: { gb: "China", fr: "Chine", de: "China" },
  "Christmas Island": {
    gb: "Christmas Island",
    fr: "Île Christmas",
    de: "Weihnachtsinsel",
  },
  "Cocos (Keeling) Islands": {
    gb: "Cocos (Keeling) Islands",
    fr: "Îles Cocos (Keeling)",
    de: "Kokosinseln",
  },
  Colombia: { gb: "Colombia", fr: "Colombie", de: "Kolumbien" },
  Comoros: { gb: "Comoros", fr: "Comores", de: "Komoren" },
  Congo: { gb: "Congo", fr: "Congo", de: "Kongo" },
  "Cook Islands": { gb: "Cook Islands", fr: "Îles Cook", de: "Cookinseln" },
  "Costa Rica": { gb: "Costa Rica", fr: "Costa Rica", de: "Costa Rica" },
  Croatia: { gb: "Croatia", fr: "Croatie", de: "Kroatien" },
  Cuba: { gb: "Cuba", fr: "Cuba", de: "Kuba" },
  Curaçao: { gb: "Curaçao", fr: "Curaçao", de: "Curaçao" },
  Cyprus: { gb: "Cyprus", fr: "Chypre", de: "Zypern" },
  "Czech Republic": {
    gb: "Czech Republic",
    fr: "République tchèque",
    de: "Tschechische Republik",
  },
  "Côte d’Ivoire": {
    gb: "Côte d’Ivoire",
    fr: "Côte d’Ivoire",
    de: "Elfenbeinküste",
  },
  "Democratic Republic of the Congo": {
    gb: "Democratic Republic of the Congo",
    fr: "République démocratique du Congo",
    de: "Demokratische Republik Kongo",
  },
  Denmark: { gb: "Denmark", fr: "Danemark", de: "Dänemark" },
  Djibouti: { gb: "Djibouti", fr: "Djibouti", de: "Dschibuti" },
  Dominica: { gb: "Dominica", fr: "Dominique", de: "Dominica" },
  "Dominican Republic": {
    gb: "Dominican Republic",
    fr: "République dominicaine",
    de: "Dominikanische Republik",
  },
  Ecuador: { gb: "Ecuador", fr: "Équateur", de: "Ecuador" },
  Egypt: { gb: "Egypt", fr: "Égypte", de: "Ägypten" },
  "El Salvador": { gb: "El Salvador", fr: "El Salvador", de: "El Salvador" },
  "Equatorial Guinea": {
    gb: "Equatorial Guinea",
    fr: "Guinée équatoriale",
    de: "Äquatorialguinea",
  },
  Eritrea: { gb: "Eritrea", fr: "Érythrée", de: "Eritrea" },
  Estonia: { gb: "Estonia", fr: "Estonie", de: "Estland" },
  Ethiopia: { gb: "Ethiopia", fr: "Éthiopie", de: "Äthiopien" },
  "Falkland Islands": {
    gb: "Falkland Islands",
    fr: "Îles Malouines",
    de: "Falklandinseln",
  },
  "Faroe Islands": { gb: "Faroe Islands", fr: "Îles Féroé", de: "Färöer" },
  Fiji: { gb: "Fiji", fr: "Fidji", de: "Fidschi" },
  Finland: { gb: "Finland", fr: "Finlande", de: "Finnland" },
  France: { gb: "France", fr: "France", de: "Frankreich" },
  "French Guiana": {
    gb: "French Guiana",
    fr: "Guyane française",
    de: "Französisch-Guayana",
  },
  "French Polynesia": {
    gb: "French Polynesia",
    fr: "Polynésie française",
    de: "Französisch-Polynesien",
  },
  "French Southern Territories": {
    gb: "French Southern Territories",
    fr: "Terres australes françaises",
    de: "Französische Süd- und Antarktisgebiete",
  },
  Gabon: { gb: "Gabon", fr: "Gabon", de: "Gabun" },
  Gambia: { gb: "Gambia", fr: "Gambie", de: "Gambia" },
  Georgia: { gb: "Georgia", fr: "Géorgie", de: "Georgien" },
  Germany: { gb: "Germany", fr: "Allemagne", de: "Deutschland" },
  Ghana: { gb: "Ghana", fr: "Ghana", de: "Ghana" },
  Gibraltar: { gb: "Gibraltar", fr: "Gibraltar", de: "Gibraltar" },
  Greece: { gb: "Greece", fr: "Grèce", de: "Griechenland" },
  Greenland: { gb: "Greenland", fr: "Groenland", de: "Grönland" },
  Grenada: { gb: "Grenada", fr: "Grenade", de: "Grenada" },
  Guadeloupe: { gb: "Guadeloupe", fr: "Guadeloupe", de: "Guadeloupe" },
  Guam: { gb: "Guam", fr: "Guam", de: "Guam" },
  Guatemala: { gb: "Guatemala", fr: "Guatemala", de: "Guatemala" },
  Guernsey: { gb: "Guernsey", fr: "Guernesey", de: "Guernsey" },
  Guinea: { gb: "Guinea", fr: "Guinée", de: "Guinea" },
  "Guinea-Bissau": {
    gb: "Guinea-Bissau",
    fr: "Guinée-Bissau",
    de: "Guinea-Bissau",
  },
  Guyana: { gb: "Guyana", fr: "Guyana", de: "Guyana" },
  Haiti: { gb: "Haiti", fr: "Haïti", de: "Haiti" },
  Honduras: { gb: "Honduras", fr: "Honduras", de: "Honduras" },
  "Hong Kong S.A.R., China": {
    gb: "Hong Kong S.A.R., China",
    fr: "R.A.S. chinoise de Hong Kong",
    de: "Hongkong",
  },
  Hungary: { gb: "Hungary", fr: "Hongrie", de: "Ungarn" },
  Iceland: { gb: "Iceland", fr: "Islande", de: "Island" },
  India: { gb: "India", fr: "Inde", de: "Indien" },
  Indonesia: { gb: "Indonesia", fr: "Indonésie", de: "Indonesien" },
  Iran: { gb: "Iran", fr: "Iran", de: "Iran" },
  Iraq: { gb: "Iraq", fr: "Irak", de: "Irak" },
  Ireland: { gb: "Ireland", fr: "Irlande", de: "Irland" },
  "Isle of Man": { gb: "Isle of Man", fr: "l'île de Man", de: "Insel Man" },
  Israel: { gb: "Israel", fr: "Israël", de: "Israel" },
  Italy: { gb: "Italy", fr: "Italie", de: "Italien" },
  Jamaica: { gb: "Jamaica", fr: "Jamaïque", de: "Jamaika" },
  Japan: { gb: "Japan", fr: "Japon", de: "Japan" },
  Jersey: { gb: "Jersey", fr: "Jersey", de: "Jersey" },
  Jordan: { gb: "Jordan", fr: "Jordanie", de: "Jordanien" },
  Kazakhstan: { gb: "Kazakhstan", fr: "Kazakhstan", de: "Kasachstan" },
  Kenya: { gb: "Kenya", fr: "Kenya", de: "Kenia" },
  Kiribati: { gb: "Kiribati", fr: "Kiribati", de: "Kiribati" },
  Kuwait: { gb: "Kuwait", fr: "Koweït", de: "Kuwait" },
  Kyrgyzstan: { gb: "Kyrgyzstan", fr: "Kirghizistan", de: "Kirgisistan" },
  Laos: { gb: "Laos", fr: "Laos", de: "Laos" },
  Latvia: { gb: "Latvia", fr: "Lettonie", de: "Lettland" },
  Lebanon: { gb: "Lebanon", fr: "Liban", de: "Libanon" },
  Lesotho: { gb: "Lesotho", fr: "Lesotho", de: "Lesotho" },
  Liberia: { gb: "Liberia", fr: "Libéria", de: "Liberia" },
  Libya: { gb: "Libya", fr: "Libye", de: "Libyen" },
  Liechtenstein: {
    gb: "Liechtenstein",
    fr: "Liechtenstein",
    de: "Liechtenstein",
  },
  Lithuania: { gb: "Lithuania", fr: "Lituanie", de: "Litauen" },
  Luxembourg: { gb: "Luxembourg", fr: "Luxembourg", de: "Luxemburg" },
  "Macao S.A.R., China": {
    gb: "Macao S.A.R., China",
    fr: "Macao R.A.S., Chine",
    de: "Macao S.A.R., China",
  },
  Macedonia: { gb: "Macedonia", fr: "Macédoine", de: "Mazedonien" },
  Madagascar: { gb: "Madagascar", fr: "Madagascar", de: "Madagaskar" },
  Malawi: { gb: "Malawi", fr: "Malawi", de: "Malawi" },
  Malaysia: { gb: "Malaysia", fr: "Malaisie", de: "Malaysia" },
  Maldives: { gb: "Maldives", fr: "Maldives", de: "Malediven" },
  Mali: { gb: "Mali", fr: "Mali", de: "Mali" },
  Malta: { gb: "Malta", fr: "Malte", de: "Malta" },
  "Marshall Islands": {
    gb: "Marshall Islands",
    fr: "Îles Marshall",
    de: "Marshallinseln",
  },
  Martinique: { gb: "Martinique", fr: "Martinique", de: "Martinique" },
  Mauritania: { gb: "Mauritania", fr: "Mauritanie", de: "Mauretanien" },
  Mauritius: { gb: "Mauritius", fr: "Île Maurice", de: "Mauritius" },
  Mayotte: { gb: "Mayotte", fr: "Mayotte", de: "Mayotte" },
  Mexico: { gb: "Mexico", fr: "Mexique", de: "Mexiko" },
  Micronesia: { gb: "Micronesia", fr: "Micronésie", de: "Mikronesien" },
  Moldova: { gb: "Moldova", fr: "Moldavie", de: "Moldawien" },
  Monaco: { gb: "Monaco", fr: "Monaco", de: "Monaco" },
  Mongolia: { gb: "Mongolia", fr: "Mongolie", de: "Mongolei" },
  Montenegro: { gb: "Montenegro", fr: "Monténégro", de: "Montenegro" },
  Montserrat: { gb: "Montserrat", fr: "Montserrat", de: "Montserrat" },
  Morocco: { gb: "Morocco", fr: "Maroc", de: "Marokko" },
  Mozambique: { gb: "Mozambique", fr: "Mozambique", de: "Mosambik" },
  Myanmar: { gb: "Myanmar", fr: "Myanmar", de: "Myanmar" },
  Namibia: { gb: "Namibia", fr: "Namibie", de: "Namibia" },
  Nauru: { gb: "Nauru", fr: "Nauru", de: "Nauru" },
  Nepal: { gb: "Nepal", fr: "Népal", de: "Nepal" },
  Netherlands: { gb: "Netherlands", fr: "Pays-Bas", de: "Niederlande" },
  "New Caledonia": {
    gb: "New Caledonia",
    fr: "Nouvelle-Calédonie",
    de: "Neukaledonien",
  },
  "New Zealand": {
    gb: "New Zealand",
    fr: "Nouvelle-Zélande",
    de: "Neuseeland",
  },
  Nicaragua: { gb: "Nicaragua", fr: "Nicaragua", de: "Nicaragua" },
  Niger: { gb: "Niger", fr: "Niger", de: "Niger" },
  Nigeria: { gb: "Nigeria", fr: "Nigéria", de: "Nigeria" },
  Niue: { gb: "Niue", fr: "Niue", de: "Niue" },
  "Norfolk Island": {
    gb: "Norfolk Island",
    fr: "Île Norfolk",
    de: "Norfolkinsel",
  },
  "North Korea": { gb: "North Korea", fr: "Corée du Nord", de: "Nordkorea" },
  "Northern Mariana Islands": {
    gb: "Northern Mariana Islands",
    fr: "Îles Mariannes du Nord",
    de: "Nördliche Marianen",
  },
  Norway: { gb: "Norway", fr: "Norvège", de: "Norwegen" },
  Oman: { gb: "Oman", fr: "Oman", de: "Oman" },
  Pakistan: { gb: "Pakistan", fr: "Pakistan", de: "Pakistan" },
  Palau: { gb: "Palau", fr: "Palaos", de: "Palau" },
  "Palestinian Territory": {
    gb: "Palestinian Territory",
    fr: "Territoire palestinien",
    de: "Palästinensische Gebiete",
  },
  Panama: { gb: "Panama", fr: "Panama", de: "Panama" },
  "Papua New Guinea": {
    gb: "Papua New Guinea",
    fr: "Papouasie-Nouvelle-Guinée",
    de: "Papua-Neuguinea",
  },
  Paraguay: { gb: "Paraguay", fr: "Paraguay", de: "Paraguay" },
  Peru: { gb: "Peru", fr: "Pérou", de: "Peru" },
  Philippines: { gb: "Philippines", fr: "Philippines", de: "Philippinen" },
  Pitcairn: { gb: "Pitcairn", fr: "Pitcairn", de: "Pitcairn" },
  Poland: { gb: "Poland", fr: "Pologne", de: "Polen" },
  Portugal: { gb: "Portugal", fr: "Portugal", de: "Portugal" },
  "Puerto Rico": { gb: "Puerto Rico", fr: "Porto Rico", de: "Puerto Rico" },
  Qatar: { gb: "Qatar", fr: "Qatar", de: "Katar" },
  Romania: { gb: "Romania", fr: "Roumanie", de: "Rumänien" },
  Russia: { gb: "Russia", fr: "Russie", de: "Russland" },
  Rwanda: { gb: "Rwanda", fr: "Rwanda", de: "Ruanda" },
  Réunion: { gb: "Réunion", fr: "La Réunion", de: "Réunion" },
  "Saint Barthélemy": {
    gb: "Saint Barthélemy",
    fr: "Saint-Barthélemy",
    de: "Saint-Barthélemy",
  },
  "Saint Helena": { gb: "Saint Helena", fr: "Sainte-Hélène", de: "St. Helena" },
  "Saint Kitts and Nevis": {
    gb: "Saint Kitts and Nevis",
    fr: "Saint-Christophe-et-Niévès",
    de: "St. Kitts und Nevis",
  },
  "Saint Lucia": { gb: "Saint Lucia", fr: "Sainte-Lucie", de: "St. Lucia" },
  "Saint Pierre and Miquelon": {
    gb: "Saint Pierre and Miquelon",
    fr: "Saint-Pierre-et-Miquelon",
    de: "St. Pierre und Miquelon",
  },
  "Saint Vincent and the Grenadines": {
    gb: "Saint Vincent and the Grenadines",
    fr: "Saint-Vincent-et-les Grenadines",
    de: "St. Vincent und die Grenadinen",
  },
  Samoa: { gb: "Samoa", fr: "Samoa", de: "Samoa" },
  "San Marino": { gb: "San Marino", fr: "Saint-Marin", de: "San Marino" },
  "Sao Tome and Principe": {
    gb: "Sao Tome and Principe",
    fr: "Sao Tomé-et-Principe",
    de: "São Tomé und Príncipe",
  },
  "Saudi Arabia": {
    gb: "Saudi Arabia",
    fr: "Arabie saoudite",
    de: "Saudi-Arabien",
  },
  Senegal: { gb: "Senegal", fr: "Sénégal", de: "Senegal" },
  Serbia: { gb: "Serbia", fr: "Serbie", de: "Serbien" },
  Seychelles: { gb: "Seychelles", fr: "Seychelles", de: "Seychellen" },
  "Sierra Leone": {
    gb: "Sierra Leone",
    fr: "Sierra Leone",
    de: "Sierra Leone",
  },
  Singapore: { gb: "Singapore", fr: "Singapour", de: "Singapur" },
  Slovakia: { gb: "Slovakia", fr: "Slovaquie", de: "Slowakei" },
  Slovenia: { gb: "Slovenia", fr: "Slovénie", de: "Slowenien" },
  "Solomon Islands": {
    gb: "Solomon Islands",
    fr: "Îles Salomon",
    de: "Salomonen",
  },
  Somalia: { gb: "Somalia", fr: "Somalie", de: "Somalia" },
  "South Africa": { gb: "South Africa", fr: "Afrique du Sud", de: "Südafrika" },
  "South Korea": { gb: "South Korea", fr: "Corée du Sud", de: "Südkorea" },
  "South Sudan": { gb: "South Sudan", fr: "Soudan du Sud", de: "Südsudan" },
  Spain: { gb: "Spain", fr: "Espagne", de: "Spanien" },
  "Sri Lanka": { gb: "Sri Lanka", fr: "Sri Lanka", de: "Sri Lanka" },
  Sudan: { gb: "Sudan", fr: "Soudan", de: "Sudan" },
  Suriname: { gb: "Suriname", fr: "Suriname", de: "Suriname" },
  "Svalbard and Jan Mayen": {
    gb: "Svalbard and Jan Mayen",
    fr: "Svalbard et Jan Mayen",
    de: "Svalbard und Jan Mayen",
  },
  Swaziland: { gb: "Swaziland", fr: "Swaziland", de: "Swasiland" },
  Sweden: { gb: "Sweden", fr: "Suède", de: "Schweden" },
  Switzerland: { gb: "Switzerland", fr: "Suisse", de: "Schweiz" },
  Syria: { gb: "Syria", fr: "Syrie", de: "Syrien" },
  Taiwan: { gb: "Taiwan", fr: "Taïwan", de: "Taiwan" },
  Tajikistan: { gb: "Tajikistan", fr: "Tadjikistan", de: "Tadschikistan" },
  Tanzania: { gb: "Tanzania", fr: "Tanzanie", de: "Tansania" },
  Thailand: { gb: "Thailand", fr: "Thaïlande", de: "Thailand" },
  "Timor-Leste": { gb: "Timor-Leste", fr: "Timor-Leste", de: "Timor-Leste" },
  Togo: { gb: "Togo", fr: "Togo", de: "Togo" },
  Tokelau: { gb: "Tokelau", fr: "Tokelau", de: "Tokelau" },
  Tonga: { gb: "Tonga", fr: "Tonga", de: "Tonga" },
  "Trinidad and Tobago": {
    gb: "Trinidad and Tobago",
    fr: "Trinité-et-Tobago",
    de: "Trinidad und Tobago",
  },
  Tunisia: { gb: "Tunisia", fr: "Tunisie", de: "Tunesien" },
  Turkey: { gb: "Turkey", fr: "Turquie", de: "Türkei" },
  Turkmenistan: { gb: "Turkmenistan", fr: "Turkménistan", de: "Turkmenistan" },
  "Turks and Caicos Islands": {
    gb: "Turks and Caicos Islands",
    fr: "Îles Turques-et-Caïques",
    de: "Turks- und Caicosinseln",
  },
  Tuvalu: { gb: "Tuvalu", fr: "Tuvalu", de: "Tuvalu" },
  "U.S. Virgin Islands": {
    gb: "U.S. Virgin Islands",
    fr: "Îles Vierges des États-Unis",
    de: "Amerikanische Jungferninseln",
  },
  Uganda: { gb: "Uganda", fr: "Ouganda", de: "Uganda" },
  Ukraine: { gb: "Ukraine", fr: "Ukraine", de: "Ukraine" },
  "United Arab Emirates": {
    gb: "United Arab Emirates",
    fr: "Émirats arabes unis",
    de: "Vereinigte Arabische Emirate",
  },
  "United Kingdom": {
    gb: "United Kingdom",
    fr: "Royaume-Uni",
    de: "Vereinigtes Königreich",
  },
  "United States Minor Outlying Islands": {
    gb: "United States Minor Outlying Islands",
    fr: "Îles mineures éloignées des États-Unis",
    de: "Amerikanisch-Ozeanien",
  },
  Uruguay: { gb: "Uruguay", fr: "Uruguay", de: "Uruguay" },
  Uzbekistan: { gb: "Uzbekistan", fr: "Ouzbékistan", de: "Usbekistan" },
  Vanuatu: { gb: "Vanuatu", fr: "Vanuatu", de: "Vanuatu" },
  Vatican: { gb: "Vatican", fr: "Vatican", de: "Vatikan" },
  Venezuela: { gb: "Venezuela", fr: "Venezuela", de: "Venezuela" },
  "Viet Nam": { gb: "Viet Nam", fr: "Viet Nam", de: "Vietnam" },
  "Wallis and Futuna": {
    gb: "Wallis and Futuna",
    fr: "Wallis-et-Futuna",
    de: "Wallis und Futuna",
  },
  "Western Sahara": {
    gb: "Western Sahara",
    fr: "Sahara occidental",
    de: "Westsahara",
  },
  Yemgb: { gb: "Yemen", fr: "Yémen", de: "Jemen" },
  Zambia: { gb: "Zambia", fr: "Zambie", de: "Sambia" },
  Zimbabwe: { gb: "Zimbabwe", fr: "Zimbabwe", de: "Simbabwe" },
};

export function getCountryOptions(locale = "gb") {
  return Object.entries(countries).map(([key, translations]) => ({
    value: key,
    label: translations[locale] || translations.gb, // Fallback to English if translation is missing
  }));
}
